import { useState } from 'react'

export const usePrescriptionDialogs = (prescriptionDownload) => {
  const [showOptionsDialog, setShowOptionsDialog] = useState(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

  const openOptionsDialog = () => setShowOptionsDialog(true)
  const closeOptionsDialog = () => setShowOptionsDialog(false)
  const closeConfirmDialog = () => setShowConfirmDialog(false)

  const handleDownloadOnly = async () => {
    closeOptionsDialog()
    await prescriptionDownload.downloadOnly()
  }

  const handleSendToPatient = () => {
    closeOptionsDialog()
    setShowConfirmDialog(true)
  }

  const handleConfirmedSendToPatient = async () => {
    closeConfirmDialog()
    await prescriptionDownload.sendToPatient()
  }

  return {
    // Dialog states
    showOptionsDialog,
    showConfirmDialog,
    
    // Dialog handlers
    openOptionsDialog,
    closeOptionsDialog,
    closeConfirmDialog,
    
    // Action handlers
    handleDownloadOnly,
    handleSendToPatient,
    handleConfirmedSendToPatient,
    
    // Loading state from prescription hook
    isLoading: prescriptionDownload.isDownloading
  }
}